export class MealToMakeReport {

    public klientId: number;
    public jmeno: string;
    public prijmeni: string;
    public turnusId: number;
    public od: Date;
    public do: Date;
    public turnusProgram: number;
    public rozsah: string;
    public denProgram: number;
    public denTyp: string;
    public denRozsah: string;
    public eko: boolean;

    public loadFromJSON(json: any): MealToMakeReport {
        this.klientId = json.id_klient;
        this.jmeno = json.jmeno;
        this.prijmeni = json.prijmeni;
        this.turnusId = json.id_turnus;
        this.od = new Date(json.od)
        this.do = new Date(json.do);
        this.turnusProgram = json.program_turnus;
        this.rozsah = json.rozsah;
        this.denProgram = json.den_program;
        this.denTyp = json.den_typ;
        this.denRozsah = json.den_rozsah;
        this.eko = json.eko === 1;
        return this;
    }

}


// WEBPACK FOOTER //
// ./src/models/reports/MealToMakeReport.tsx